import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=51067b00&scoped=true"
import script from "./preview.vue?vue&type=script&lang=js"
export * from "./preview.vue?vue&type=script&lang=js"
import style0 from "./preview.vue?vue&type=style&index=0&id=51067b00&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51067b00",
  null
  
)

export default component.exports